import { Link } from 'react-router-dom';
import { SIGNUP_URL } from '../config';

export function AboutPage() {
  return (
    <>
      <section className="px-6 pt-28 pb-16 lg:px-10 lg:pt-36 lg:pb-20">
        <div className="mx-auto grid max-w-[1280px] items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <div>
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-brand/15 bg-brand-light px-3 py-1.5 text-[0.72rem] font-bold tracking-widest text-brand uppercase">
              About cevop
            </div>
            <h1 className="font-display mb-5 text-[2.75rem] leading-[1.06] font-extrabold text-ink lg:text-[3.375rem]">
              Businesses deserve
              <br />
              to know their numbers.
            </h1>
            <p className="text-[1.0625rem] leading-[1.7] text-ink-2">
              cevop was built because running a business that sells — managing stock, controlling cash and understanding
              financial performance — is harder than it should be.
            </p>
          </div>
          <div className="rounded-2xl bg-inverse p-8 lg:p-10">
            <div className="mb-5 text-[0.65rem] font-bold tracking-widest text-inverse-fg/25 uppercase">What we believe</div>
            <div className="space-y-4">
              {[
                ['A business owner should be able to know their cash position right now.', 'Not at the end of the month.'],
                ['Stock should update from the work — when you keep stock.', 'Not wait for a monthly recount to matter.'],
                ['A sale at the counter should instantly become business information.', 'Not a spreadsheet entry two days later.'],
              ].map(([headline, sub]) => (
                <div key={headline} className="border-l-2 border-brand/40 pl-4">
                  <div className="text-[0.85rem] font-semibold text-inverse-fg">{headline}</div>
                  <div className="mt-0.5 text-[0.78rem] text-inverse-fg/40">{sub}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="border-y border-line bg-surface-2/60 px-6 py-20 lg:px-10">
        <div className="mx-auto grid max-w-[1280px] gap-12 lg:grid-cols-2">
          <div>
            <h2 className="font-display mb-5 text-[2rem] font-extrabold text-ink">
              Powerful enough to run the business. Simple enough to actually use.
            </h2>
            <p className="mb-5 text-[0.95rem] leading-[1.7] text-ink-3">
              We are NGN-first. Built with Nigerian businesses in mind — cash, bank transfer, card, the realities of
              Nigerian retail.
            </p>
          </div>
          <div className="mk-stagger space-y-5">
            {[
              {
                title: 'Not a restaurant platform',
                desc: 'cevop is for businesses that sell — retail, convenience, pharmacy, fashion, beauty, electronics, wholesale, and similar counters. Not table service, kitchen tickets, or dining areas.',
              },
              {
                title: 'Not an AI product',
                desc: 'cevop is deterministic. Sales records are accurate because they are calculated. Your P&L is correct because every transaction is accounted for.',
              },
              {
                title: 'Not just a cash register',
                desc: 'Sell in POS. Run stock, buying, sales, and money in Business. Every sale can update books and stock from the same system.',
              },
            ].map((item) => (
              <div key={item.title} className="mk-lift rounded-2xl border border-line bg-panel p-5 shadow-sm">
                <div className="font-display mb-2 text-[0.9rem] font-bold text-ink">{item.title}</div>
                <div className="text-[0.82rem] leading-[1.65] text-ink-3">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-inverse px-6 py-16 lg:px-10">
        <div className="mx-auto max-w-[640px] text-center">
          <h2 className="font-display mb-4 text-[2rem] text-inverse-fg">Start with cevop today.</h2>
          <div className="flex flex-col justify-center gap-3 sm:flex-row">
            <a
              href={SIGNUP_URL}
              className="inline-flex items-center justify-center rounded-xl bg-brand px-8 py-3.5 font-semibold text-brand-on hover:bg-brand-hover"
            >
              Start free
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center rounded-xl border border-inverse-fg/15 px-8 py-3.5 font-semibold text-inverse-fg hover:bg-inverse-fg/5"
            >
              Get in touch
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
